"use strict";
// The registry's display rules (SPEC §7.1, CR-001 §5.11), in one place for the API, the screens, CSV
// exports and tests (D-974). Standard library only: the web bundle and the server both load it.
Object.defineProperty(exports, "__esModule", { value: true });
exports.roundHalfUp = roundHalfUp;
exports.formatCount = formatCount;
exports.formatRate = formatRate;
exports.formatReportingRate = formatReportingRate;
exports.formatPerformanceRate = formatPerformanceRate;
exports.formatPerformanceWithCounts = formatPerformanceWithCounts;
exports.formatPoints = formatPoints;
exports.formatQuality = formatQuality;
exports.formatStratumCount = formatStratumCount;
exports.barFill = barFill;
exports.formatProjectionPercent = formatProjectionPercent;
const EM_DASH = "—";
const COUNT_FORMAT = new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 });
// Half-up rounding through the decimal exponent, so 8.575 rounds to 8.58 instead of the 8.57 that
// binary floating point gives for Math.round(8.575 * 100) / 100. Rates and points are never negative.
function roundHalfUp(value, decimals) {
    return Number(`${Math.round(Number(`${value}e${decimals}`))}e-${decimals}`);
}
/** Counts: thousands separator. 1279 → `1,279`. */
function formatCount(count) {
    return COUNT_FORMAT.format(count);
}
/**
 * CR-005 item 9 (J-191): one display rule for every rate and completeness, on every screen and export:
 * half-up to one decimal, the decimal always shown. 26.86 → `26.9%`; 70 → `70.0%`; null → `—`. The
 * Data page's load preview, the ACO summary's checklist and Analysis's 26.86 then agree.
 */
function formatRate(rate) {
    return rate === null ? EM_DASH : `${roundHalfUp(rate, 1).toFixed(1)}%`;
}
/** Reporting rate (data completeness): `formatRate`. 68.86 → `68.9%`; null → `—`. */
function formatReportingRate(rate) {
    return formatRate(rate);
}
/** Performance rate: `formatRate`. 66.666 → `66.7%`; null → `—`. */
function formatPerformanceRate(rate) {
    return formatRate(rate);
}
/**
 * A gap-inclusive performance cell (CR-002 CR2-023): the rate by `formatRate` and the counts with
 * thousands separators. (58.8235, 30, 51) → `58.8% (30/51)`; (null, 0, 0) → `— (0/0)`.
 */
function formatPerformanceWithCounts(rate, numerator, denominator) {
    return `${formatPerformanceRate(rate)} (${formatCount(numerator)}/${formatCount(denominator)})`;
}
/** Points and scores: 1 decimal, trailing `.0` stripped. 8.0 → `8`; 7.4 → `7.4`. */
function formatPoints(points) {
    return String(roundHalfUp(points, 1));
}
/** Quality: `{earned}/{max}` in points format; `—` when the maximum is 0 (nothing scored, D-1016). */
function formatQuality(earned, max) {
    return max === 0 ? EM_DASH : `${formatPoints(earned)}/${formatPoints(max)}`;
}
/** Stratum counts: the count followed by `***`. 3 → `3***`; 1279 → `1,279***`. */
function formatStratumCount(count) {
    return `${formatCount(count)}***`;
}
/**
 * Performance bar fill, 0–100: the rate for a normal row and 100 − rate for an inverse measure or
 * stratum, so a longer bar always means better performance.
 */
function barFill(rate, direction) {
    return direction === "inverse" ? roundHalfUp(100 - rate, 2) : rate;
}
/** Score Est. projection: half-up to 1 decimal, trailing `.0` stripped. 52.333 → `52.3%`; null → `—`. */
function formatProjectionPercent(score) {
    return score === null ? EM_DASH : `${roundHalfUp(score, 1)}%`;
}
//# sourceMappingURL=format.js.map